import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SignUpData {
  email: string;
  password: string;
  authCode: string;
  isEmailValid: boolean;
  isPasswordValid: boolean;
  isPasswordConfirmValid: boolean;
  isAuthCodeVerified: boolean;
}

interface SignUpContextType {
  signUpData: SignUpData;
  updateSignUpData: (data: Partial<SignUpData>) => void;
  clearSignUpData: () => void;
}

const initialSignUpData: SignUpData = {
  email: '',
  password: '',
  authCode: '',
  isEmailValid: false,
  isPasswordValid: false,
  isPasswordConfirmValid: false,
  isAuthCodeVerified: false,
};

const SignUpContext = createContext<SignUpContextType | undefined>(undefined);

export const SignUpProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [signUpData, setSignUpData] = useState<SignUpData>(initialSignUpData);

  const updateSignUpData = (data: Partial<SignUpData>) => {
    setSignUpData(prev => ({ ...prev, ...data }));
  };

  const clearSignUpData = () => {
    setSignUpData(initialSignUpData);
  };

  return (
    <SignUpContext.Provider value={{ signUpData, updateSignUpData, clearSignUpData }}>
      {children}
    </SignUpContext.Provider>
  );
};

export const useSignUp = (): SignUpContextType => {
  const context = useContext(SignUpContext);
  if (context === undefined) {
    throw new Error('useSignUp must be used within a SignUpProvider');
  }
  return context;
};
